module.exports = __webpack_public_path__ + "img/UsingData-small.26fda95c.png";